import React from 'react';
import { ArrowLeft, Play, Navigation, ScanLine, ClipboardCheck } from 'lucide-react';

function DeliveryListHeader({
  setActiveComponent,
  onStartRoute,
  canStartRoute,
  loadingRoutes,
  routeStarted,
  onOpenScanner,
  onOpenBulkReceive
}) {
  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-3 gap-2">
        {/* Back Button */}
        <button
          onClick={() => setActiveComponent('OptionsDriver')}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
          aria-label="Volver"
        >
          <ArrowLeft className="w-6 h-6 text-gray-700" />
        </button>

        {/* Action Buttons Container */}
        <div className="flex items-center gap-2 flex-1 justify-end">
          {/* Bulk Receive Button */}
          <button
            onClick={onOpenBulkReceive}
            className="p-2 rounded-lg bg-brand-gold hover:bg-brand-gold/90 text-white transition-all shadow-sm flex-shrink-0"
            aria-label="Recibir paquetes"
            title="Recibir paquetes"
          >
            <ClipboardCheck className="w-5 h-5" />
          </button>

          {/* Scanner Button */}
          <button
            onClick={onOpenScanner}
            className="p-2 rounded-lg bg-brand-primary hover:bg-brand-primary/90 text-white transition-all shadow-sm flex-shrink-0"
            aria-label="Escanear paquete"
            title="Escanear paquete"
          >
            <ScanLine className="w-5 h-5" />
          </button>

          {/* Start Route Button */}
          <button
            onClick={onStartRoute}
            disabled={!canStartRoute || loadingRoutes}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all flex-shrink-0
              ${canStartRoute && !loadingRoutes
                ? 'bg-brand-green text-white hover:bg-brand-green/90 shadow-md'
                : routeStarted
                ? 'bg-brand-green/70 text-white cursor-not-allowed'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }
            `}
            aria-label={routeStarted ? 'Ruta iniciada' : 'Iniciar ruta'}
          >
            {loadingRoutes ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span className="text-sm hidden sm:inline">Procesando...</span>
              </>
            ) : routeStarted ? (
              <>
                <Navigation className="w-5 h-5" />
                <span className="text-sm hidden sm:inline">En Ruta</span>
              </>
            ) : (
              <>
                <Play className="w-5 h-5" />
                <span className="text-sm hidden sm:inline">Iniciar Ruta</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeliveryListHeader;